import React from 'react';
import { motion } from 'framer-motion';
export function ExpectedResults() {
  const results = [{
    num: '30%',
    color: 'text-brand-cyan',
    title: 'Sueño más profundo',
    desc: 'Aumento en fases reparadoras desde la primera semana'
  }, {
    num: '2-3 kg',
    color: 'text-brand-purple',
    title: 'Menos peso inflamatorio',
    desc: 'Reducción de inflamación sistémica en Semana 2'
  }, {
    num: '48h',
    color: 'text-brand-gold',
    title: 'Claridad mental',
    desc: 'Primera mejora cognitiva al eliminar los 3 jinetes'
  }, {
    num: '0',
    color: 'text-brand-red drop-shadow-[0_0_15px_rgba(255,71,87,0.5)]',
    title: 'Crash de las 3 PM',
    desc: 'Desaparece por completo en la primera semana'
  }];
  return <section className="py-24 px-6 bg-brand-bg" data-id="element-316">
      <div className="max-w-[1000px] mx-auto" data-id="element-317">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-318">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-319">
            Lo Que Esperar en los Primeros 30 Días
          </h2>
          <p className="text-xl text-brand-muted" data-id="element-320">
            Resultados medibles de bioquímica aplicada con consistencia
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-321">
          {results.map((res, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-brand-card rounded-[20px] p-10 text-center border border-brand-border hover:border-brand-border/80 transition-colors" data-id="element-322">
              <div className={`font-display text-5xl md:text-6xl font-bold mb-4 ${res.color}`} data-id="element-323">
                {res.num}
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-324">{res.title}</h3>
              <p className="text-sm text-brand-muted leading-relaxed" data-id="element-325">
                {res.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}